import React from 'react';
import ModalUI from "../ModalsUI/index";
import FooterDefault from "../FootersUI/FooterDefault";
import DragPopUp from "../HelpersUI/DragPopUp";

export default function LevarDebutTheme() {
    return (
        <React.Fragment>
            <ModalUI />
            <DragPopUp />
            <FooterDefault />
        </React.Fragment>
    )
}